import { SagaIterator } from 'redux-saga';
import { all, takeEvery, call, put } from 'redux-saga/effects';
import { requestPuppy, isApiError } from '@wix/da-http-client';
import {
  watchTopic,
  watchTopicSuccess,
  watchTopicFailure,
  unwatchTopic,
  unwatchTopicSuccess,
  unwatchTopicFailure,
  suppressTopic,
  suppressTopicSuccess,
  suppressTopicFailure,
} from './actions';

export function* handleWatchTopic({
  payload: { params, onSuccess },
}: ReturnType<typeof watchTopic>) {
  const { necoid, suggested_neco_id_lists = [], source } = params;
  const result = yield call(requestPuppy, {
    method: 'post',
    url: '/topic/watch',
    data: {
      necoid,
      suggested_neco_id_lists: JSON.stringify(suggested_neco_id_lists),
      source,
    },
  });

  if (!result || isApiError(result)) {
    yield put(watchTopicFailure(params));
  } else {
    yield put(watchTopicSuccess(params, result));
    onSuccess && onSuccess(result);
  }
}

export function* handleUnwatchTopic({
  payload: { params, onSuccess },
}: ReturnType<typeof unwatchTopic>) {
  const result = yield call(requestPuppy, {
    method: 'post',
    url: '/topic/unwatch',
    data: params,
  });

  if (!result || isApiError(result)) {
    yield put(unwatchTopicFailure(params));
  } else {
    yield put(unwatchTopicSuccess(params, result));
    onSuccess && onSuccess(result);
  }
}

export function* handleSuppressTopic({
  payload: { params, onSuccess },
}: ReturnType<typeof suppressTopic>) {
  const result = yield call(requestPuppy, {
    method: 'post',
    url: '/topic/suppress',
    data: params,
  });

  if (!result || isApiError(result)) {
    yield put(suppressTopicFailure(params));
  } else {
    yield put(suppressTopicSuccess(params, result));
    onSuccess && onSuccess(result);
  }
}

export default function* saga(): SagaIterator {
  yield all([
    takeEvery(watchTopic, handleWatchTopic),
    takeEvery(unwatchTopic, handleUnwatchTopic),
    takeEvery(suppressTopic, handleSuppressTopic),
  ]);
}
